import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

function FooterBrand() {
  return (
    <div className="md:col-span-2">
      <div className="flex items-center gap-3 mb-5">
        <img
          src="https://customer-assets.emergentagent.com/job_agent-funding-pro/artifacts/arvd4npc_image.jpeg"
          alt="Hannah Howard Funding logo"
          className="w-11 h-11 rounded-md object-cover ring-1 ring-[#5A3B31]"
        />
        <span className="font-serif-lux text-3xl">
          Hannah Howard <span className="text-[#CBA4A4]">Funding</span>
        </span>
      </div>
      <p className="text-[#CBA4A4] max-w-md leading-relaxed">
        Fast real estate commission advances designed for licensed agents and brokers. Access earned commissions sooner — with no credit check and same-day funding potential.
      </p>
      <div className="mt-8 space-y-3 text-sm">
        <p className="flex items-center gap-3">
          <Phone size={16} strokeWidth={1.5} className="text-[#F3D8DA]" />
          <a href="tel:+18709199520" className="hover:text-[#F3D8DA]">
            Questions? Call: (870) 919-9520
          </a>
        </p>
        <p className="flex items-center gap-3">
          <Mail size={16} strokeWidth={1.5} className="text-[#F3D8DA]" />
          <a
            href="mailto:hello@hannahhowardfunding.com"
            className="hover:text-[#F3D8DA]"
          >
            hello@hannahhowardfunding.com
          </a>
        </p>
        <p className="text-xs text-[#CBA4A4] leading-relaxed">
          Mailing Address: 495 Brickell Ave, Miami, FL 33131
        </p>
      </div>
    </div>
  );
}

function FooterLinks({ title, items, testId }) {
  return (
    <div data-testid={testId}>
      <p className="overline text-[#CBA4A4] mb-5">{title}</p>
      <ul className="space-y-3 text-sm">
        {items.map((it) => (
          <li key={it.to}>
            {it.onClick ? (
              <button
                type="button"
                onClick={it.onClick}
                data-testid={it.testId}
                className="hover:text-[#F3D8DA] text-left"
              >
                {it.label}
              </button>
            ) : (
              <Link to={it.to} className="hover:text-[#F3D8DA]">
                {it.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

const EXPLORE = [
  { to: "/", label: "Home" },
  { to: "/apply", label: "Apply Now" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/login", label: "Login" },
];

const openCookiePrefs = () => {
  window.dispatchEvent(new CustomEvent("hh:open-cookie-preferences"));
};

const LEGAL = [
  { to: "/terms", label: "Terms of Use" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/cookies", label: "Cookie Policy" },
  { to: "/communications-consent", label: "Communications Consent" },
  { to: "/esign-consent", label: "E-SIGN Consent" },
  { to: "/application-authorization", label: "Application Authorization" },
  { to: "/disclaimer", label: "Website Disclaimer" },
  { to: "/privacy-request", label: "Privacy Request" },
  {
    to: "#",
    label: "Cookie Settings",
    onClick: openCookiePrefs,
    testId: "footer-cookie-settings",
  },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#2A1C14] text-[#FCFAF8] print:hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <FooterBrand />
        <FooterLinks title="Explore" items={EXPLORE} testId="footer-explore" />
        <FooterLinks title="Legal" items={LEGAL} testId="footer-legal" />
      </div>
      <div className="border-t border-[#5A3B31]/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 text-xs text-[#CBA4A4] leading-relaxed">
          <p className="mb-3">
            Hannah Howard Funding provides commission advance services subject to eligibility, verification, approval, and applicable terms. Same-day funding is not guaranteed. Any commission advance transaction is governed by a separate written Funding Agreement.
          </p>
          <p>© 2026 Hannah Howard Funding. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
